import { render, staticRenderFns } from "./FarmerApplicationRecordDetails.vue?vue&type=template&id=6fc8e6ef&scoped=true"
import script from "./FarmerApplicationRecordDetails.vue?vue&type=script&lang=js"
export * from "./FarmerApplicationRecordDetails.vue?vue&type=script&lang=js"
import style0 from "./FarmerApplicationRecordDetails.vue?vue&type=style&index=0&id=6fc8e6ef&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc8e6ef",
  null
  
)

export default component.exports